import { Route, Routes } from 'react-router-dom'

import CustomDeadLines from './screens/CustomDeadlines'
import ProviderDeadlines from './screens/ProviderDeadlines'
import PublicationDeadlines from './screens/PublicationDeadlines'
import TodaysDeadLines from './screens/TodaysDeadLines'

const DeadlineRoutes = () => (
  <Routes>
    <Route index element={<TodaysDeadLines />} />
    <Route path="/customDeadLines" element={<CustomDeadLines />} />
    <Route path="/providers" element={<ProviderDeadlines />} />
    <Route path="/publications" element={<PublicationDeadlines />} />
  </Routes>
)

export default DeadlineRoutes
